import { getApiBaseUrl } from '@/config/apiBaseUrl'

const apiBaseUrl = getApiBaseUrl()

export default {
  loginEndpoint: `${apiBaseUrl}/login`,
  registerEndpoint: `${apiBaseUrl}/register`,
  refreshEndpoint: '/logout',
  logoutEndpoint: '/logout',

  tokenType: 'Bearer',

  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
